import styled from 'styled-components';

const MaxWidth = styled.div`
  width: 100%;
  max-width: 58.25rem;
  margin-right: auto;
  margin-left: auto;
  padding: 0 1.25rem;
`;

export default MaxWidth;
